exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cp-footer {\n  height: 60px;\n  width: 100%;\n  line-height: 60px;\n  text-align: center;\n  background-color: #8a94a2;\n  color: #e6e6e6;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#3296FA"}}!./src/components/footer/index.less
// module id = 431
// module chunks = 0